import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import Illustration from "../../../../partials/content/Illustration";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import DialogLayout from "../../../../partials/content/DialogLayout";
import LicensesForm from "./LicensesForm";
import {
  deleteLicense,
  getLicenses,
} from "../../../../services/sales/salesService";
function Licenses({ history }) {
  const { reload } = useGlobalData();
  const [openLicenseForm, setOpenLicenseForm] = useState(false);
  const [licenses, setLicenses] = useState([]);
  const [license, setLicense] = useState({ ID: 0 });
  const [auth, setAuth] = useState({ create: false });
  const licenseDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
  ];
  actionButtons.push({
    title: "New License",
    color: "primary",
    icon: "fas fa-plus-circle",
    onClick: () => {
      setOpenLicenseForm(true);
    },
  });
  useEffect(() => {
    getLicenseData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="License List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/license/license-list",
            title: "Licenses",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        {licenses.length ? (
          <CustomDataTable
            data={licenses}
            dataDetailColumns={licenseDetailColumn}
            onRefreshData={() => {
              getLicenseData();
            }}
            tableName="discount"
            selectionMode="checkbox"
            columns={[
              {
                selectionMode: "multiple",
              },
              {
                header: "License ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "License Key",
                field: "licenseKey",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.licenseKey} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Level",
                field: "globalCustomerLevelName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.globalCustomerLevelName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Deployment Type",
                field: "globalCustomerDeploymentTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.globalCustomerDeploymentTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Billing Type",
                field: "globalCustomerBillingTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.globalCustomerBillingTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Customer",
                field: "customerName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Edit License">
                      <button
                        type="button"
                        onClick={(event) => {
                          setLicense(rowData);
                          setOpenLicenseForm(true);
                        }}
                        className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete License">
                      <button
                        type="button"
                        onClick={() => {
                          handleDeleteLicense(rowData.ID);
                        }}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Sales.png"
            description="Hooray! You're ready to have your first License Key!"
            guidance=""
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={openLicenseForm}
        title="LicenseForm"
        onCloseDialog={() => {
          setOpenLicenseForm(false);
        }}
        maxWIdth="md"
      >
        <LicensesForm
          licenseImp={license}
          onConfirmSave={() => {
            getLicenseData();
            setOpenLicenseForm(false);
          }}
          onCloseDialog={() => {
            setOpenLicenseForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleDeleteLicense(licenseID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this License ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteLicense(licenseID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getLicenseData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getLicenseData() {
    const response = await getLicenses();
    const { data, auth } = response.data;
    setAuth(auth);
    setLicenses(data.licenses);
  }
}

export default Licenses;
